import { watchPosition, clearWatch, getPosition } from '../helpers/helpers'
import { MDCSwitch } from '@material/switch'
import { toNumber } from 'lodash'

export default class LocationFilter {
  constructor () {
    this.auto = false
    this._filter = document.getElementById('basic-switch')
    this.switch = new MDCSwitch(document.getElementById('location-filter-switch'))
    this.wrapper = document.getElementById('location-filter')
    this.filter = {
      latitude: undefined,
      longitude: undefined
    }
  }

  static get EVENT () {
    return {
      CHANGE: 'poin:locationFilter:change'
    }
  }

  async init () {
    const queryParams = new URLSearchParams(window.location.search)
    const latitude = queryParams.get('latitude')
    const longitude = queryParams.get('longitude')

    this._filter.addEventListener('change', async (event) => {
      await this.change()
    })

    if (latitude && longitude) {
      this.filter.latitude = toNumber(latitude)
      this.filter.longitude = toNumber(longitude)
      this.on()
    }
  }

  async change () {
    if (this.switch.checked) {
      try {
        const position = await getPosition({ enableHighAccuracy: true })
        this.filter.latitude = position.coords.latitude
        this.filter.longitude = position.coords.longitude
      } catch (err) {
        this.filter.latitude = undefined
        this.filter.longitude = undefined

        if (err.code === 1 && err.message === 'User denied Geolocation') {
          this.switch.checked = false
        }
      }
    } else {
      this.filter.latitude = undefined
      this.filter.longitude = undefined
    }

    this._filter.dispatchEvent(new Event(LocationFilter.EVENT.CHANGE, { bubbles: true }))
  }

  async watch () {
    if (this.switch.checked) {
      try {
        const watcher = await watchPosition({ enableHighAccuracy: true })
        this.watchID = watcher.id
        this.filter.latitude = watcher.position.coords.latitude
        this.filter.longitude = watcher.position.coords.longitude
      } catch (err) {
        this.filter.latitude = undefined
        this.filter.longitude = undefined

        if (err.code === 1 && err.message === 'User denied Geolocation') {
          this.switch.checked = false
        }
      }
    } else {
      clearWatch(this.watchID)
      this.filter.latitude = undefined
      this.filter.longitude = undefined
    }

    this._filter.dispatchEvent(new Event(LocationFilter.EVENT.CHANGE, { bubbles: true }))
  }

  on (options) {
    this.auto = !!options?.auto
    this.switch.checked = true
    this.change()
  }

  off (options) {
    this.auto = !!options?.auto
    this.switch.checked = false
    this.change()
  }

  enable () {
    this.switch.disabled = false
    this.wrapper.classList.remove('blocked')
  }

  disable () {
    this.switch.disabled = true
    this.filter.longitude = undefined
    this.filter.latitude = undefined
    this.wrapper.classList.add('blocked')
  }

  filterIsSet () {
    return Boolean(this.filter.latitude && this.filter.longitude)
  }

  hasBeenAutoSet () {
    return this.auto
  }
}
